import React from 'react';
import { Drawer as DrawerBW } from 'baseui/drawer';
import { mergeOverrides, styled } from 'baseui';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { drawerTitlesText } from './styles';
import { StyleObject } from 'styletron-react';
import { useStyletron } from '../../Themes';

type EpoType = IDummyProps;
export const View = React.forwardRef((props: EpoType, ref: any) => {
	const { maintitle, subtitle, overrides, ...rest } = props;
	const [isDettached, setDettached] = React.useState(false);
	const [css, theme] = useStyletron();
	const myRef = React.useRef<any>();

	const onDettach = (event: any) => {
		setDettached((_d: boolean) => !_d)
	}

	const DrawerComponent = () => {
		return (
			<DrawerBW
				{...rest}
				ref={ref}
				overrides={
					overrides
						? mergeOverrides(customOverrides(props, theme, css, onDettach, isDettached), overrides as any)
						: customOverrides(props, theme, css, onDettach, isDettached)
				}
				mountNode={myRef.current}
			>
				{maintitle && <DrawerTitleView>{maintitle}</DrawerTitleView>}
				{subtitle && <DrawerSubtitleView>{subtitle}</DrawerSubtitleView>}
				{props.children}
			</DrawerBW>
		);
	}
	return (
		<>
			<DrawerComponent />
			<span ref={myRef}></span>
		</>
	);

});

export const DrawerTitleView = styled('h1', () => {
	return drawerTitlesText('h1') as StyleObject;
});

export const DrawerSubtitleView = styled('h2', () => {
	return drawerTitlesText('h2') as StyleObject;
});
